import { z } from 'zod';

// --- Legacy boolean toggle (backward compatible) ---

export const ChecklistItemSchema = z.object({
  id: z.number().int().positive(),
  completado: z.boolean(),
});

export const BulkChecklistUpdateSchema = z.object({
  items: z.array(ChecklistItemSchema).min(1).max(200),
});

// --- EstadoActividad enum values ---

export const EstadoActividadEnum = z.enum(['OK', 'NOK', 'NA']);

export const EstadoActividadValues = ['OK', 'NOK', 'NA'] as const;
export type EstadoActividadValue = (typeof EstadoActividadValues)[number];

// --- Update actividad with estado + observaciones ---

export const UpdateActividadEstadoSchema = z.object({
  estadoActividad: EstadoActividadEnum.nullable().optional(),
  observaciones: z.string().max(2000).nullable().optional(),
});

// --- Types ---

export type ChecklistItem = z.infer<typeof ChecklistItemSchema>;
export type BulkChecklistUpdate = z.infer<typeof BulkChecklistUpdateSchema>;
export type UpdateActividadEstado = z.infer<typeof UpdateActividadEstadoSchema>;
